__turbopack_context__.v({
  "buttonGroup": "LearnStrip-module-scss-module__JQfA0a__buttonGroup",
  "header": "LearnStrip-module-scss-module__JQfA0a__header",
  "heading": "LearnStrip-module-scss-module__JQfA0a__heading",
  "inner": "LearnStrip-module-scss-module__JQfA0a__inner",
  "navButton": "LearnStrip-module-scss-module__JQfA0a__navButton",
  "root": "LearnStrip-module-scss-module__JQfA0a__root",
  "slide": "LearnStrip-module-scss-module__JQfA0a__slide",
  "status": "LearnStrip-module-scss-module__JQfA0a__status",
  "swiper": "LearnStrip-module-scss-module__JQfA0a__swiper",
  "track": "LearnStrip-module-scss-module__JQfA0a__track",
});
